"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AdjustmentCategory {
}
exports.AdjustmentCategory = AdjustmentCategory;
//# sourceMappingURL=AdjustmentCategory.js.map